import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

interface QuizHeaderProps {
  isBookmarked: boolean;
  onBookmarkToggle: () => void;
  isCompleted: boolean;
  isFinalExam?: boolean;
}

const QuizHeader: React.FC<QuizHeaderProps> = ({
  isBookmarked,
  onBookmarkToggle,
  isCompleted,
  isFinalExam = false,
}) => {
  return (
    <>
      <IconButton
        onClick={onBookmarkToggle}
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 10,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
          },
        }}
      >
        {isBookmarked ? (
          <BookmarkIcon
            sx={{ color: ' rgba(245, 52, 75, 0.9)', fontSize: 32 }}
          />
        ) : (
          <BookmarkBorderIcon sx={{ color: 'text.secondary', fontSize: 32 }} />
        )}
      </IconButton>

      {isCompleted && (
        <Box
          sx={{
            backgroundColor: 'rgba(76, 175, 80, 0.1)',
            border: '1px solid rgba(76, 175, 80, 0.3)',
            borderRadius: '8px',
            padding: '12px 16px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            sx={{
              color: 'rgb(76, 175, 80)',
              fontWeight: 600,
              fontSize: '1rem',
            }}
          >
            ✓ {isFinalExam ? 'Exam' : 'Round'} Completed - View Only Mode
          </Typography>
        </Box>
      )}
    </>
  );
};

export default QuizHeader;
